import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
// import { Button, Card, CardContent, Grid, TextField, Typography, Container, CssBaseline, InputLabel, styled, IconButton } from "@material-ui/core";
import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  Container,
  CssBaseline,
  InputLabel,
  styled,
  IconButton,
  colors,
} from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Toast } from "@egovernments/digit-ui-react-components";
import { TLService } from "../../../../../../../libraries/src/services/elements/TL";
import { Fade } from "@mui/material";
import { flatten } from "lodash";
import InputContainer from "../../TCPForms/layout/inputContainer";
import ButtonWrapper from "../../TCPForms/components/Button";
import InputWrapper from "@egovernments/digit-ui-module-obps/src/pages/citizen/AVPForms/layout/inputWrapper";
import { ownerOrLtp } from "@egovernments/digit-ui-module-obps/src/pages/citizen/TCPForms/data";
import { useTranslation } from "react-i18next";

const StyledTextField = styled(TextField)(() => ({
  "& .MuiOutlinedInput-input": { padding: "5px 5px", height: "5px", width: "94%" },
}));

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    // backgroundImage: 'url("https://t3.ftcdn.net/jpg/02/99/39/50/360_F_299395041_SEg76lLpIaGAPRjI3uPqIdd3nm3ecRpv.jpg")',
    backgroundSize: "cover",
    backgroundPosition: "center center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    objectFit: "cover",
    imageRendering: "auto",
    opacity: ".85",
  },
  overlay: {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(255, 255, 255, 0.8)", // Adjust the opacity (last value) as needed
  },
  card: {
    backgroundColor: "#e9f5ff",
    height: "100%",
  },
  logo: {
    width: "90px",
    height: "80px",
  },
  header: {
    marginBottom: "20px",
    textDecoration: "none",
  },
  textField: {
    // marginBottom: "20px",
    width: "94%",
  },
  button: {
    // marginTop: "20px",
    width: "223px",
    height: "35px",
    borderRadius: "1px",
  },
}));

const EmployeeLogin2 = ({ handleFlip, flipped }) => {
  const classes = useStyles();
  const stateId = Digit.ULBService.getStateId();
  const getUserType = () => Digit.UserService.getType();
  const { t } = useTranslation();
  const setEmployeeDetail = (userObject, token) => {
    let locale = JSON.parse(sessionStorage.getItem("Digit.locale"))?.value || "en_IN";
    localStorage.setItem("Employee.tenant-id", userObject?.tenantId);
    localStorage.setItem("tenant-id", userObject?.tenantId);
    localStorage.setItem("citizen.userRequestObject", JSON.stringify(userObject));
    localStorage.setItem("locale", locale);
    localStorage.setItem("Employee.locale", locale);
    localStorage.setItem("token", token);
    localStorage.setItem("Employee.token", token);
    localStorage.setItem("user-info", JSON.stringify(userObject));
    localStorage.setItem("Employee.user-info", JSON.stringify(userObject));
  };
  const { data: storeData, isLoading: isStoreLoading } = Digit.Hooks.useStore.getInitData();
  const { stateInfo } = storeData || {};
  const navigate = useHistory();
  const [loginSection, setLoginSection] = useState(true);
  const { register, handleSubmit, watch, control } = useForm();
  const [user, setUser] = useState(null);
  const [showOtpField, setOtpField] = useState(false);
  const [showsecotpField, setSecondOtpField] = useState(false);
  const [showName, setName] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const [disable, setDisable] = useState(true);
  const [captcha, setCaptcha] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaVisible, setCaptchaVisible] = useState(false);
  const [otpTimer, setOtpTimer] = useState(0);
  const [resendDisabled, setResendDisabled] = useState(true);
  const [otpTimerKey, setOtpTimerKey] = useState(0);

  useEffect(() => {
    if (!user) {
      return;
    }

    Digit.SessionStorage.set("citizen.userRequestObject", user);
    const filteredRoles = user?.info?.roles?.filter((role) => role.tenantId === Digit.SessionStorage.get("Employee.tenantId"));
    if (user?.info?.roles?.length > 0) user.info.roles = filteredRoles;
    Digit.UserService.setUser(user);
    setEmployeeDetail(user?.info, user?.access_token);
    let redirectPath = "/digit-ui/employee";

    if (window?.location?.href?.includes("from=")) {
      redirectPath = decodeURIComponent(window?.location?.href?.split("from=")?.[1]) || "/digit-ui/employee";
    }

    if (user?.info?.roles && user?.info?.roles?.every((e) => e.code === "NATADMIN")) {
      redirectPath = "/digit-ui/employee/payment/integration/dss/NURT_DASHBOARD";
    }

    if (user?.info?.roles && user?.info?.roles?.every((e) => e.code === "STADMIN")) {
      redirectPath = "/digit-ui/employee/payment/integration/dss/home";
    }

    history.replace(redirectPath);
  }, [user]);
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 2000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  useEffect(() => {
    generateCaptcha(6, true);
  }, []);

  useEffect(() => {
    if (captcha === captchaInput) {
      setDisable(false);
    } else {
      setDisable(true);
    }
    console.log({ captcha, captchaInput }, "captcha");
  }, [captcha, captchaInput]);

  useEffect(() => {
    let timer;
    if (showOtpField || showsecotpField) {
      setOtpTimer(60);
      setResendDisabled(true);
      timer = setInterval(() => {
        setOtpTimer((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            setResendDisabled(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [showOtpField, showsecotpField, otpTimerKey]);

  const generateCaptcha = (length, isAlphanumeric) => {
    // Example CAPTCHA generation logic
    let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    if (!isAlphanumeric) {
      characters = "0123456789";
    }
    let result = "";
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    setCaptcha(result);
    setCaptchaVisible(true); // Make the input field and CAPTCHA visible after generation
  };
  const trackEscalteApplication = async () => {
    const result = await TLService.workflowEsclate();
  };
  // useEffect(() => {
  //   trackEscalteApplication();
  // }, []);

  const onLogin = async (data) => {
    if (captcha !== captchaInput) {
      setShowToast({ error: true, message: `Invalid CAPTCHA` });
      setTimeout(closeToast, 5000);
      return;
    }

    setDisable(true);
    const requestData = {
      username: data?.username,
      password: data?.password,
      userType: "EMPLOYEE",
    };
    requestData.tenantId = tenantId;
    delete requestData.city;
    try {
      const { UserRequest: info, ...tokens } = await Digit.UserService.authenticate(requestData);
      Digit.SessionStorage.set("Employee.tenantId", info?.tenantId);
      setUser({ info, ...tokens });
    } catch (err) {
      setShowToast({ error: true, message: `Invalid Login Credential` });
      setTimeout(closeToast, 5000);
    }
    setDisable(false);
  };

  const closeToast = () => {
    setShowToast(null);
  };

  const onForgotPassword = () => {
    history.push("/digit-ui/employee/user/forgot-password");
  };
  useEffect(() => {
    if (captcha.trim() === captchaInput.trim()) {
      setDisable(false); // Enable button if CAPTCHA matches
    } else {
      setDisable(true); // Disable button if CAPTCHA doesn't match
    }
  }, [captcha, setCaptchaInput]);
  const onSubmit = async (data) => {
    console.log(data);
    const { mobileNumber, otp, registeredName } = data;
    if (!showOtpField && !showName) {
      const requestData = {
        otp: {
          mobileNumber: mobileNumber,
          userType: "citizen",
          type: "login",
          tenantId: stateId,
        },
      };
      try {
        const res = await Digit.UserService.sendOtp(requestData, stateId);
        if (res?.isSuccessful) {
          setOtpField(true);
        }
      } catch (err) {
        setName(true);
        setShowToast({ error: true, message: `New User? Please register your detail in the portal` });
      }
    }
    console.log(otp, registeredName, showName, showOtpField, showsecotpField, "alllllll");
    if (showsecotpField) {
      const requestData = {
        name: registeredName,
        username: mobileNumber,
        otpReference: otp,
        tenantId: stateId,
        mobileNumber: mobileNumber,
        tempRole: data?.tempRole,
      };
      try {
        const { ResponseInfo, UserRequest: info, ...tokens } = await Digit.UserService.registerUser(requestData, stateId);
        Digit.SessionStorage.set("citizen.userRequestObject", { info, ...tokens });
        Digit.UserService.setUser({ info, ...tokens });
        navigate.push("/digit-ui/citizen/profile");
      } catch (error) {
        setShowToast({ error: true, message: `OTP is Wrong, please try again!` });
      }
    }
    if (showName && !showOtpField && !showsecotpField) {
      const requestData = {
        otp: {
          mobileNumber: mobileNumber,
          name: registeredName,
          userType: "citizen",
          type: "register",
          tenantId: stateId,
        },
      };
      try {
        const res = await Digit.UserService.sendOtp(requestData, stateId);
        if (res?.isSuccessful) {
          setSecondOtpField(true);
        }
      } catch (err) {
        setShowToast({ error: true, message: `Something went wrong, please try again!` });
      }
    }
    if (showOtpField && !showName) {
      const requestData = {
        username: mobileNumber,
        password: otp,
        tenantId: stateId,
        userType: getUserType(),
      };
      try {
        const { ResponseInfo, UserRequest: info, ...tokens } = await Digit.UserService.authenticate(requestData);
        console.log("outSideIfLogin", info);

        if (info?.uuid) {
          console.log("insideIfLogin", info);

          Digit.SessionStorage.set("citizen.userRequestObject", { info, ...tokens });
          Digit.UserService.setUser({ info, ...tokens });
          navigate.push("/digit-ui/citizen/profile");
        } else {
          setShowToast({ error: true, message: `Something went wrong, please try again!` });
        }
      } catch (error) {
        setShowToast({ error: true, message: `Wrong OTP, please try again!` });
      }
    }
  };

  const handleResendOtp = async () => {
    // Use the same logic as OTP generation
    const mobileNumber = watch("mobileNumber");
    const registeredName = watch("registeredName");
    let requestData;
    if (showsecotpField) {
      requestData = {
        otp: {
          mobileNumber: mobileNumber,
          name: registeredName,
          userType: "citizen",
          type: "register",
          tenantId: stateId,
        },
      };
    } else {
      requestData = {
        otp: {
          mobileNumber: mobileNumber,
          userType: "citizen",
          type: "login",
          tenantId: stateId,
        },
      };
    }
    try {
      const res = await Digit.UserService.sendOtp(requestData, stateId);
      if (res?.isSuccessful) {
        setOtpField(true);
        setSecondOtpField(showsecotpField);
        setOtpTimerKey((prev) => prev + 1); // <-- This triggers the interval again
        setOtpTimer(60);
        setResendDisabled(true);
      }
    } catch (err) {
      setShowToast({ error: true, message: `Unable to resend OTP. Please try again.` });
    }
  };

  return (
    <React.Fragment>
      {showToast && <Toast style={{ left: "50 %" }} error={showToast?.error} label={showToast?.message} onClose={closeToast} />}

      {loginSection && (
        <section className="citizen-login-section">
          <form onSubmit={handleSubmit(onSubmit)} className="citizen-login-form" autoComplete="off">
            <div>
              <h3 className="citizen-label-homepage">{"ENTER MOBILE No."}</h3>
              <InputWrapper
                control={control}
                hasLabel={false}
                disabled={showsecotpField || showOtpField}
                // placeholder="Enter Mobile No."
                width={"100%"}
                height={"24px"}
                name="mobileNumber"
                type="number"
                maxWidth={"10"}
                inputClassName="input-citizen-homepage"
                // label={"Enter Mobile No."}
                mobileNumber
                maxLength={10}
                validation={{
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                  pattern: {
                    value: Digit.Utils.getPattern("MobileNo"),
                    message: "Please enter valid mobile no",
                  },
                }}
              />

              {showName && (
                <React.Fragment>
                  <h3 className="citizen-label-homepage">Enter Name</h3>
                  <InputWrapper
                    control={control}
                    // placeholder="Enter Name"
                    width={"100%"}
                    height={"24px"}
                    //defaultValue={owner.mobileNumber}
                    name="registeredName"
                    type="textInput"
                    inputClassName="input-citizen-homepage"
                    hasLabel={false}
                    // label={"Enter Name"}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("SearchOwnerName"),
                        message: "Please enter only letters and space",
                      },
                    }}
                  />
                </React.Fragment>
              )}
              {showName && (
                <div
                  style={{
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h3 className="citizen-label-homepage">Registered As</h3>
                  <InputWrapper
                    control={control}
                    width={"100%"}
                    name="tempRole"
                    type="radioButton"
                    inputClassName="input-citizen-homepage"
                    hasLabel={false}
                    data={ownerOrLtp}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </div>
              )}
              {(showOtpField || showsecotpField) && (
                <React.Fragment>
                  <h3 className="citizen-label-homepage">Enter OTP</h3>
                  <InputWrapper
                    hasLabel={false}
                    control={control}
                    // placeholder="Enter OTP"
                    inputClassName="input-citizen-homepage"
                    width={"100%"}
                    height={"24px"}
                    //defaultValue={owner.mobileNumber}
                    name="otp"
                    type="password"
                    // label={"Enter OTP."}
                    maxLength={6}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    // style={{
                    //   display: "block",
                    //   width: "100%",
                    //   padding: "10px",
                    //   fontSize: "14px",
                    //   border: "1px solid #ccc",
                    //   borderRadius: "4px",
                    //   marginBottom: "1rem",
                    //   boxSizing: "border-box",
                    // }}
                  />
                </React.Fragment>
              )}
            </div>
            <div style={{ display: "flex", justifyContent: "space-evenly", textAlign: "center", marginTop: "0.5rem" }}>
              <ButtonWrapper
                variant="contained"
                size="small"
                background={"#4caf50"}
                label="FASTPASS.HOME.COMMON.SUBMIT"
                type="submit"
                // sx={{ background: "#4caf50", width: "10%", marginBottom: "1rem" }}
              />
              {/* <div style={{ textAlign: "center", marginTop: "1rem", color: "#fff" }}> */}
              <ButtonWrapper
                onClick={handleFlip}
                variant="contained"
                size={"small"}
                style={{ backgroundColor: "#3B4B95", color: "#fff" }}
                label={"FASTPAS.HOME.DEPARTMENT.LOGIN"}
              />
              {/* </div> */}
            </div>
            {(showOtpField || showsecotpField) && (
              <div style={{ display: "flex", alignItems: "center", margin: "8px 0px 0px 4px" }}>
                <Typography variant="body2" sx={{ mr: 2, color: "white" }}>
                  {resendDisabled ? `Resend OTP in ${otpTimer}s` : "Didn't receive OTP?"}
                </Typography>
                <ButtonWrapper
                  onClick={handleResendOtp}
                  variant="contained"
                  size={"small"}
                  style={{ backgroundColor: "#3B4B95", color: "#fff" }}
                  label={"Resend OTP"}
                  disabled={resendDisabled}
                />
              </div>
            )}
          </form>
        </section>
      )}
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={showToast?.message} onClose={closeToast} isDeleteBtn={true} />
      )}
    </React.Fragment>
  );
};

export default EmployeeLogin2;
